export const convertToCelcius = (value) => (value - 32) * (5 / 9);
